import React from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { colors } from '../../../../../constants'

export const MediaItemDom = styled.div`
    height: 150px;
    width: 100%;
    cursor: pointer;
    ${({ alert }) => alert && `background: #FFF1F1;`}
    ${({ disabled }) => disabled && `background: #E6EDF1;`}
`

export const Body = styled.div`
    height: 81%;
    width: 100%;
`

export const Footer = styled.div`
    font-size: 12px;
    height: 18%;
    width: 100%;
    text-align: left;
`

export const Label = styled.span`
    color: ${colors.grey};
    font-size: 15px;
`

export const Value = styled.span`
    color: ${colors.bluedark};
    font-size: 15px;
    margin-left: 5px;
`

export const ValueGroup = styled.div`
    height: 22px;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:not(:first-child) {
        margin-top: 5px;
    }

    ${({ nomargin }) => !nomargin && 'margin-top: 10px'}

    ${({ withAction }) =>
        withAction &&
        `
      &:hover {
        opacity: 0.6;
      }
    `}
`

export const MediaButtons = styled.div`
    position: absolute;
    right: 10px;
    top: 8px;

    & > button:not(:last-child) {
        margin-right: 5px;
    }
`

export const SelectedIconWrapper = styled(FontAwesomeIcon)`
    position: absolute;
    transition: all 0.3s;
    transform: scale(0, 0);
    top: 10px;
    transform-origin: top;
    ${({ selected }) => selected && `transform: scale(1, 1);`};
    right: 10px;
    color: ${colors.red};
`

export const SelectedIcon = (props) => <SelectedIconWrapper {...props} icon="check-circle" />

const InfoIconWrapper = styled(FontAwesomeIcon)`
    position: absolute;
    transition: all 0.3s;
    top: 10px;
    left: 10px;
    color: ${({ alert }) => (alert ? colors.reddark : colors.blue)};
`

export const InfoIcon = (props) => <InfoIconWrapper {...props} icon="info-circle" />

const MediaButtonsIconWrapper = styled(FontAwesomeIcon)`
    color: ${colors.white};
`


export const EditIcon = (props) => <MediaButtonsIconWrapper {...props} icon="edit" />

const ExclamationIconWrapper = styled(FontAwesomeIcon)`
    margin-right: 5px;
`

export const ExclamationIcon = (props) => <ExclamationIconWrapper {...props} icon="exclamation-triangle" />

export const ExclamationIconInfo = (props) => <InfoIconWrapper {...props} icon="exclamation-triangle" />

export const ExclamationCircleIcon = (props) => <ExclamationIconWrapper {...props} icon="exclamation-circle" />

export const BackgroundPlayIcon = styled.div`
    position: absolute;
    height: 100%;
    width: 100%;
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0);
    border-right: solid ${colors.greylighter} 1px;
    z-index: 2;

    &:hover {
        background-color: rgba(0, 0, 0, 0.3);
    }
`

export const LoadingIcon = styled(FontAwesomeIcon)`
    color: ${colors.black};
    ${({ big }) => big && 'font-size: 30px;'}
`

export const PlayIcon = styled(FontAwesomeIcon)`
    color: ${colors.white};
`

export const IconWrapper = styled.div`
    position: absolute;
    height: 20px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
`

export const BarberBackground = styled.div`
    background-image: repeating-linear-gradient(-45deg, ${colors.bluelight}, ${colors.bluelight} 1rem, ${colors.blue} 1rem, ${colors.blue} 2rem);
    background-size: 200% 200%;
    color: white;
    font-weight: bold;
    text-shadow: 0 0 2px #00000050;
    width: 100%;

    animation: barberpole 30s linear infinite;
    @keyframes barberpole {
        100% {
            background-position: 100% 100%;
        }
    }
`

export const FooterButton = styled.button`
    background: transparent;
    border: 0;
    color: ${({ alert }) => (alert ? colors.reddark : colors.blue)};
    height: 100%;
    padding-bottom: 5px;
    width: 100%;

    ${({ disabled }) =>
        !disabled &&
        ` cursor: pointer;
      &:hover {
        color: ${({ alert }) => (alert ? colors.red : colors.bluedark)};
      }`}

    &:focus {
        outline: none;
    }
`

export const MediaTypeIcon = styled.div`
    color: #bebebe;
    font-size: 18px;
    position: absolute;
    top: 5px;
    left: 10px;
    z-index: 3;
`

export const MediaPlaylists = styled.div`
    color: ${colors.grey};
    font-size: 15px;
    display: inline-block;
`

export const AudioThumbnail = styled.div`
    color: ${colors.greylight};
    top: 50%;
    left: 50%;
    font-size: 70px;
    transform: translate(-50%, -50%);
    position: absolute;
    z-index: 0;
`

